import {DashboardConfiguration} from '../types';

export class User {
    private static instance: User;

    private storage: any = {};

    private constructor() {
    }

    public static getInstance(): User {
        if (!User.instance) {
            User.instance = new User();
        }

        return User.instance;
    }

    public setEmail(email: string): void {
        this.storage['user.email'] = email;
        localStorage.setItem('user.email', email);
    }

    public getEmail(): string {
        //return this.storage['user.email'] || '';
        return localStorage.getItem('user.email') || '';
    }

    public setDisplayName(s: string): void {
        this.storage['user.displayName'] = s;
        localStorage.setItem('user.displayName', s);
    }

    public getDisplayName(): string {
        //return this.storage['user.displayName'] || this.getEmail();
        return localStorage.getItem('user.displayName') || this.getEmail();
    }

    public setRoles(roles: string[]): void {
        this.storage['user.roles'] = JSON.stringify(roles);
        localStorage.setItem('user.roles', JSON.stringify(roles));
    }

    public getRoles(): string[] {
        const rolesJson = localStorage.getItem('user.roles');
        //const rolesJson = this.storage['user.roles'];
        if (rolesJson) {
            try {
                return JSON.parse(rolesJson);
            } catch (e) {
                return [];
            }
        }
        return [];
    }

    public hasRole(role: string): boolean {
        const roles = User.getInstance().getRoles();
        return roles.includes(role) || roles.includes('itadmin');
    }

    /**
     * Returns whether the user has the IS WFO role
     */
    public isIsWfo(): boolean {
        return (this.hasRole('is_wfo') || this.hasRole('is_support'));
    }

    public setAuthToken(token: string): void {
        console.log('setting token', token);
        window.localStorage.setItem('user', token);
        this.storage['user'] = token;
    }

    public getAuthToken(): string | null {
        //return this.storage['user'];
        return window.localStorage.getItem('user');
    }

    public deleteAuthToken(): void {
        localStorage.clear();
        this.storage = {};
    }

    public setSelectedTags(tags: any): void {
        localStorage.setItem('workflowListSelectedTags', JSON.stringify(tags));
    }

    public getSelectedTags(): any {
        const tagsJson = localStorage.getItem('workflowListSelectedTags');
        if (tagsJson) {
            try {
                return JSON.parse(tagsJson);
            } catch (e) {
                return [];
            }
        }
        return [];
    }

    public setInboxFilter(filter: any): void {
        localStorage.setItem('inboxFilters', JSON.stringify(filter));
    }

    public getInboxFilter(): any {
        const filtersJson = localStorage.getItem('inboxFilters');
        if (filtersJson) {
            try {
                return JSON.parse(filtersJson);
            } catch (e) {
                return {};
            }
        }
        return {};
    }

    public getPrintAllDetails(): boolean {
        return localStorage.getItem('print-all-details') === 'Yes';
    }

    public setPrintAllDetails(b: boolean): void {
        localStorage.setItem('print-all-details', b ? 'Yes' : 'No');
    }

    public getShowStepAssigneesFilter(defaultValue = false): boolean {
        const showStepAssignees = localStorage.getItem('search-show-step-assignees-filter');
        if (showStepAssignees === null) {
            return defaultValue;
        }
        return showStepAssignees === 'Yes';
    }

    public setShowStepAssigneesFilter(b: boolean): void {
        localStorage.setItem('search-show-step-assignees-filter', b ? 'Yes' : 'No');
    }

    public getDashboardConfiguration(dashboardId: number): DashboardConfiguration {
        const configJson = localStorage.getItem(`dashboard-config-${dashboardId}`);
        if (configJson) {
            try {
                return JSON.parse(configJson);
            } catch (e) {
                return {} as DashboardConfiguration;
            }
        }
        return {} as DashboardConfiguration;
    }

    public setDashboardConfiguration(dashboardId: number, configuration: DashboardConfiguration): void {
        localStorage.setItem(`dashboard-config-${dashboardId}`, JSON.stringify(configuration));
    }
}